import { render } from "./IconPhone.vue?vue&type=template&id=1a95b690"
import script from "./IconPhone.vue?vue&type=script&lang=js"
export * from "./IconPhone.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__